import { SkipToContentStyle } from './skip-to-content.styles';

export const SkipToContent = () => (
    <SkipToContentStyle href="#main-content" role="region" aria-label="skip to main content">
        Skip to main content
    </SkipToContentStyle>
);
